/* Gumb v glavi za prijavo napake + pripadajoči modal.
   [PATCH napake-fe v1]
   Stoji ob zvoncu, a je od njega popolnoma neodvisen — ObvestilaZvonec
   ostaja nespremenjen. */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useNapakeStore } from '../stores/napakeStore';
import { PrijavaNapakeModal } from './PrijavaNapakeModal';

export function PrijavaNapakeGumb() {
  const odpri = useNapakeStore((s) => s.odpri);
  return (
    <>
      <button onClick={odpri} title="Prijavi napako"
        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400">
        <AlertTriangle className="w-5 h-5" />
      </button>
      <PrijavaNapakeModal />
    </>
  );
}
